(function() {
'use strict';

angular
    .module('core')
    .factory('crossSellService', crossSellService);

function crossSellService(analytics,
                          crossSellCommonService,
                          enumService,
                          imageService,
                          flightExtrasService,
                          $q) {
    const crossSellKeyByProductType = {
        1: 'Flight',
        2: 'Attractions',
        4: 'CarHire',
        8: 'Hotels',
        16: 'Parking',
        32: 'Transfer'
    };

    const maxCrossSell = 4;
    const maxSameType = 2;

    const service = {
        getBookingCrossSell,
        getTripCrossSell,
        getCrossSellProbability,
        startCrossSellJourney,
        addExtrasAndCrossSells
    };

    function getBookingCrossSell(bookingId) {
        return crossSellCommonService.getBookingCrossSell(bookingId).then(processData);
    }

    function addExtrasAndCrossSells(tr) {
        let crossSells = [];
        let addBaggage = [];
        getTripCrossSell(tr, true).then(cs => {
            crossSells = cs || [];
            updateTripWithCrossSells();
        });
        getExtras(tr).then(ab => {
            addBaggage = ab || [];
            updateTripWithCrossSells();
        });

        function updateTripWithCrossSells() {
            tr.crossSellProducts = _mergeExtrasAndCrossSells(addBaggage, crossSells);
        }
    }

    function getTripCrossSell(tr) {
        return crossSellCommonService.getTripCrossSell(tr, service.getBookingCrossSell);
    }

    function getExtras(tr) {
            const flightBookingType = 1;
            const flightBooking = _.find(tr.Bookings, b => b.Type === flightBookingType);
            return TRPCONFIG.Domain.DashboardAddBagsEnabled && flightBooking
                ? flightExtrasService.getExtrasCrossSell(flightBooking.BookingId)
                : $q.when([]);
    }

    function _mergeExtrasAndCrossSells(extras, crossSells) {
        const crossSellToReplace = crossSells.length + extras.length - maxCrossSell;
        if (crossSellToReplace > 0) {
            _.remove(crossSells, cs =>
                cs.Priority >= crossSells.length - crossSellToReplace);
        }
        _.each(crossSells, cs => { cs.Priority += extras.length; });
        return extras.concat(crossSells);
    }

    function processData(result) {
        if (!result) {
            return [];
        }
        const crossSells = result.data;
        return filterCrossSellByPriority(crossSells).map(cs =>
            _.extend(cs, { roundedCurrency: true }));
    }

    function startCrossSellJourney(bookingId, crossSellProduct) {
        crossSellCommonService.startCrossSellJourney(bookingId, crossSellProduct);
    }

    function getCrossSellImage(product) {
        switch (product.ProductType) {
            case enumService.ProductType.Hotel:
                return imageService.getMainImageUrl(product.EstabId, 400, 140, true);
            case enumService.ProductType.Transfer:
                return '/build/img/assets/product/transfers.jpg';
            case enumService.ProductType.CarHire:
                return '/build/img/assets/car_hire.jpg';
            case enumService.ProductType.Parking:
                return '/build/img/assets/car_parking.jpg';
            case enumService.ProductType.Attraction:
                return `/attractions/Handlers/crosssellimage.ashx?acsid=${product.Id}`;
            default:
                return '';
        }
    }

    function addProperties(productType, product, type) {
        const productToDisplay = _.merge(_.omit(productType, 'CrossSells'), product);
        _.assignIn(productToDisplay, type);
        productToDisplay.Image = getCrossSellImage(productToDisplay);
        productToDisplay.Price = productToDisplay.AdultPrice || productToDisplay.Price;
        productToDisplay.Title = productToDisplay.Title || productToDisplay.Description || productToDisplay.CarPark;
        return productToDisplay;
    }

    function getCrossSellProbability(basketId, productTypes) {
        return crossSellCommonService.getBasketCrossSell(basketId).then(function(data) {
            const result = {};
            _.forEach(data, function(i) {
                if (productTypes.indexOf(i.Product) !== -1) {
                    result[i.Product] = i.Probability;
                }
            });

            analytics.track('Event', 'BasketCrossSell', { BasketId: basketId, ProductProbability: result });
            analytics.track('mixpanel', 'BasketCrossSell', {
                ProductProbabilityCarHire: result[enumService.ProductType.CarHire],
                ProductProbabilityTransfer: result[enumService.ProductType.Transfer]
            });

            return result !== {} ? result : null;
        });
    }

    function filterCrossSellByPriority(crossSell) {
        const filteredCrossSell = {};
        const simplifiedCrossSellList = [];
        let counter = 0;
        if (crossSell.Priorities.length > 0) {
            const priorities = _.sortBy(crossSell.Priorities, p => p.Order);
            _.times(maxCrossSell, c => {
                if (counter >= priorities.length) {
                    counter = 0;
                }
                const key = crossSellKeyByProductType[priorities[counter].Type];
                if (!filteredCrossSell[key]) {
                    filteredCrossSell[key] = [];
                }
                if (filteredCrossSell[key].length < maxSameType) {
                    let cs = crossSell[key].CrossSells[filteredCrossSell[key].length];
                    if (cs) {
                        cs.Priority = c;
                        cs = addProperties(crossSell[key], cs, crossSellCommonService.productTypeProperties[key]);
                        filteredCrossSell[key].push(cs);
                    }
                }
                counter++;
            });
            _.each(priorities, p => simplifiedCrossSellList.push(...filteredCrossSell[crossSellKeyByProductType[p.Type]]));
        }
        return simplifiedCrossSellList;
    }


    return service;
}
})();
